export default {"src":"/_next/static/media/upload1.9922d59e.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};